import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient } from '@/lib/queryClient'
import { createRole, deleteRole, fetchRoles, updateRole, type RoleWriteBody } from './api'

export const ROLES_KEY = ['roles'] as const

// Outbox keys (see apps/frontend/AGENTS.md "offline outbox").
export const ROLE_CREATE_KEY = ['outbox', 'roles', 'create'] as const
export const ROLE_UPDATE_KEY = ['outbox', 'roles', 'update'] as const
export const ROLE_DELETE_KEY = ['outbox', 'roles', 'delete'] as const

queryClient.setMutationDefaults(ROLE_CREATE_KEY, { mutationFn: createRole })
queryClient.setMutationDefaults(ROLE_UPDATE_KEY, {
  mutationFn: ({ id, body }: { id: string; body: RoleWriteBody }) => updateRole(id, body),
})
queryClient.setMutationDefaults(ROLE_DELETE_KEY, { mutationFn: deleteRole })

export function useRoles() {
  return useQuery({
    queryKey: ROLES_KEY,
    queryFn: fetchRoles,
  })
}

export function useCreateRole() {
  const qc = useQueryClient()
  return useMutation({
    mutationKey: ROLE_CREATE_KEY,
    mutationFn: (body: RoleWriteBody) => createRole(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ROLES_KEY }),
  })
}

export function useUpdateRole() {
  const qc = useQueryClient()
  return useMutation({
    mutationKey: ROLE_UPDATE_KEY,
    mutationFn: ({ id, body }: { id: string; body: RoleWriteBody }) => updateRole(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ROLES_KEY }),
  })
}

export function useDeleteRole() {
  const qc = useQueryClient()
  return useMutation({
    mutationKey: ROLE_DELETE_KEY,
    mutationFn: (id: string) => deleteRole(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ROLES_KEY }),
  })
}
